var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { FormStyles } from "@/components/styles/FormStyles";
import { useWidgetStore } from "@/providers/WidgetsContextProvider";
import { EXPORT_BALLOT_PUBLICATION } from "@/queries/ExportBallotPublication";
import { IPermissions } from "@/types/keycloak";
import { ETasksExecution } from "@/types/tasksExecution";
import { useMutation } from "@apollo/client";
import { Dialog } from "@sequentech/ui-essentials";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { DownloadDocument } from "../User/DownloadDocument";
import { useRecordContext } from "react-admin";
import { ListActions } from "@/components/ListActions";
import { useTenantStore } from "@/providers/TenantContextProvider";
var PublishExport = function (_a) {
    var ballotPublicationId = _a.ballotPublicationId;
    var _b = useState(false), openExport = _b[0], setOpenExport = _b[1];
    var _c = useState(false), exporting = _c[0], setExporting = _c[1];
    var record = useRecordContext();
    var tenantId = useTenantStore()[0];
    var _d = useState(), exportDocumentId = _d[0], setExportDocumentId = _d[1];
    var t = useTranslation().t;
    var _e = useWidgetStore(), addWidget = _e[0], setWidgetTaskId = _e[1], updateWidgetFail = _e[2];
    var ExportBallotPublication = useMutation(EXPORT_BALLOT_PUBLICATION, {
        context: {
            headers: {
                "x-hasura-role": IPermissions.PUBLISH_WRITE,
            },
        },
    })[0];
    var handleExport = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setExporting(false);
            setExportDocumentId(undefined);
            setOpenExport(true);
            return [2 /*return*/];
        });
    }); };
    var confirmExportAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var currWidget, _a, ballotResponse, errors, documentId, task_id, error_1;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 2, , 3]);
                    currWidget = addWidget(ETasksExecution.EXPORT_BALLOT_PUBLICATION, undefined);
                    return [4 /*yield*/, ExportBallotPublication({
                            variables: {
                                tenantId: tenantId,
                                electionEventId: record.election_event_id
                                    ? record.election_event_id
                                    : record.id,
                                electionId: record.election_event_id ? record.id : null,
                                ballotPublicationId: ballotPublicationId,
                            },
                        })];
                case 1:
                    _a = _e.sent(), ballotResponse = _a.data, errors = _a.errors;
                    setExporting(true);
                    if (errors) {
                        setExporting(false);
                        updateWidgetFail(currWidget.identifier);
                        return [2 /*return*/];
                    }
                    documentId = (_b = ballotResponse === null || ballotResponse === void 0 ? void 0 : ballotResponse.export_ballot_publication) === null || _b === void 0 ? void 0 : _b.document_id;
                    setExportDocumentId(documentId);
                    task_id = (_d = (_c = ballotResponse === null || ballotResponse === void 0 ? void 0 : ballotResponse.export_ballot_publication) === null || _c === void 0 ? void 0 : _c.task_execution) === null || _d === void 0 ? void 0 : _d.id;
                    task_id
                        ? setWidgetTaskId(currWidget.identifier, task_id)
                        : updateWidgetFail(currWidget.identifier);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _e.sent();
                    console.log(error_1);
                    setExporting(false);
                    currWidget && updateWidgetFail(currWidget.identifier);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsx(ListActions, { withExport: true, withColumns: false, withImport: false, withFilter: false, doExport: handleExport }), _jsxs(Dialog, __assign({ variant: "info", open: openExport, ok: t("common.label.export"), okEnabled: function () { return !exporting; }, cancel: t("common.label.cancel"), title: t("common.label.export"), handleClose: function (result) {
                    if (result) {
                        confirmExportAction();
                    }
                    else {
                        setExportDocumentId(undefined);
                        setExporting(false);
                        setOpenExport(false);
                    }
                } }, { children: [t("common.export"), _jsxs(FormStyles.ReservedProgressSpace, { children: [exporting ? _jsx(FormStyles.ShowProgress, {}) : null, exporting && exportDocumentId ? (_jsx(DownloadDocument, { documentId: exportDocumentId, fileName: "ballot-publication-export.json", onDownload: function () {
                                    setExportDocumentId(undefined);
                                    setExporting(false);
                                    setOpenExport(false);
                                } })) : null] })] }))] }));
};
export default PublishExport;
